/* eslint semi:0 */
import { getElementById, } from 'utils/dom'
import { toIdentityObject, } from 'utils/array'
import { domainWithTldFromFqdn } from 'utils/ua'
import navbarActions from 'actions/navbarActions'
import { mithrilHelpers, m, } from 'utils/mithril'
import postMetadataStore from 'stores/postMetadataStore'
import { SELECTORS, } from 'config/preRenderedSelectorsConfig'
import { get as getFromPdo, } from 'application/pageDataObject'
import socialButtonsActions from 'actions/socialButtonsActions'
import { t, locale, } from 'providers/i18nProvider/i18nProvider'
import facebookCommentsActions from 'actions/facebookCommentsActions'
require('scroll-to-element')


const FACEBOOK_COMMENTS_FEATURE_ID = 'FacebookComments'
const EMBED_CODE_FEATURE_ID = 'EmbedCode'
const { urlWithQs, } = mithrilHelpers

const EMPTY_HREF = 'javascript:' //eslint-disable-line no-script-url
const TERMS = [
  'title', 'text', 'icon',
  'href', 'onclick', 'target',
  '_blank', 'sourceName', 'popupWidth',
  'popupHeight', 'children',
  'featureId',
]
let T = {}
TERMS.forEach(toIdentityObject, T)


function getSiteHeaderOffsetValue(){
  let headerHeight = parseFloat(getComputedStyle(getElementById(SELECTORS.SITE_HEADER.slice(1))).height)
  headerHeight = headerHeight > 0 ? -headerHeight - 20 : 0
  return headerHeight
}

const TWITTER_VIA = {
  "90min.com": {
    default: "90min_Football",
  },
  "ftb90.com": {
    default: "ftb_90",
  },
  "12up.com": {
    default: "12upSport",
    es: "12up_ES",
  },
}

function twitterVia(){
  const forDomain = TWITTER_VIA[domainWithTldFromFqdn]
  return forDomain && (forDomain[locale] || forDomain.default)
}

const SOCIAL_BUTTONS_CONF = {

  facebook: {
    [T.title]: 'Facebook',
    [T.icon]: 'facebook',
    get [T.href](){
      const sharedUrlParams = {
        utm_source: this[T.sourceName], // eslint-disable-line camelcase
        utm_medium: 'share', // eslint-disable-line camelcase
      }
      const urlParams = {
        u: urlWithQs(getFromPdo('post.url'), sharedUrlParams),
      }
      return urlWithQs('http://www.facebook.com/sharer.php', urlParams)
    },
    [T.target]: T._blank,
    [T.sourceName]: 'facebook.com',
    [T.onclick]: socialButtonsActions.facebookShare,
  },
  twitter: {
    [T.title]: t('common.tweet'),
    [T.icon]: 'twitter',
    get [T.href](){
      const sharedUrlParams = {
        utm_source: this[T.sourceName], // eslint-disable-line camelcase
        utm_medium: 'share', // eslint-disable-line camelcase
      }
      const urlParams = {
        text: getFromPdo('post.title', '').replace('|', '-'),
        via: twitterVia(),
        url: urlWithQs(getFromPdo('post.url'), sharedUrlParams),
      }
      return urlWithQs('http://twitter.com/share', urlParams)
    },
    [T.target]: T._blank,
    [T.sourceName]: 'twitter.com',
    [T.onclick]: socialButtonsActions.twitterShare,
  },
  message: {
    [T.title]: t('common.share'),
    [T.icon]: 'message',
    [T.onclick]: navbarActions.navbarMobileMessageShare,
    [T.href]: EMPTY_HREF,
  },
  googlePlus: {
    [T.title]: t('common.share'),
    [T.icon]: 'googlePlus',
    [T.onclick]: navbarActions.navbarMobileGooglePlusShare,
    [T.href]: EMPTY_HREF,
  },
  whatsapp: {
    [T.title]: t('common.share'),
    [T.icon]: 'whatsapp',
    [T.sourceName]: 'whatsapp',
    get [T.href]() {
      const sharedUrlParams = {
        utm_source: this[T.sourceName], // eslint-disable-line camelcase
        utm_medium: 'share', // eslint-disable-line camelcase
      }
      const postUrl = urlWithQs(getFromPdo('post.url'), sharedUrlParams)
      return [
        'whatsapp://send?text=',
        getFromPdo('post.title'),
        encodeURIComponent(`: ${ postUrl }`),
      ].join('')
    },
    [T.onclick]: socialButtonsActions.whatsappShare,
  },
  embed: {
    [T.featureId]: EMBED_CODE_FEATURE_ID,
    [T.title]: t('embed.button'),
    [T.icon]: 'embed',
    [T.onclick]: socialButtonsActions.openEmbed,
    [T.href]: EMPTY_HREF,
  },
  comments: {
    [T.featureId]: FACEBOOK_COMMENTS_FEATURE_ID,
    [T.title]: t('common.comments_box_num'),
    [T.icon]: 'comments',
    [T.href]: EMPTY_HREF,
    get [T.onclick](){
      return function facebookCommentsClickHandler(caller, e){
        if (caller.ctrl.options.rootSelector !== SELECTORS.FOOTER_SOCIAL_ICONS){
          facebookCommentsActions.scrollToFacebookComments({
            scrollToElementSelector: SELECTORS.FACEBOOK_COMMENTS,
            offset: getSiteHeaderOffsetValue(),
            ease: 'inQuad',
            duration: 1000,
          })
        }
        facebookCommentsActions.loadFacebookComments()
      }
    },
    get [T.children](){
      const commentsCount = postMetadataStore.getCount('comments')
      const commentsCountLabel = commentsCount ? `(${ commentsCount })` : ''
      return [
        m('span.share-component__btn--comments__text', t('common.comments_box_num')),
        m('b.share-component__btn--comments__value', commentsCountLabel),
      ]
    },
  },

}

export default SOCIAL_BUTTONS_CONF


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/config/socialButtonsConfig.js